import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css';

const element = document.querySelector(".code-block");
const commentElement = document.querySelector(".comment");

const promiseCode = `function fetchImagesWithPromise() {
  const promises = [];
  for (let column = 0; column < NR_OF_COLUMNS; column+=COL_INCREMENT) {
    for (let row = 0; row < NR_OF_ROWS; row+=ROW_INCREMENT) {
      // Here we use the Promise stucture to fetch the image
      const promise = fetchBlobImage().then((blob) => {
         const element = imageContainer.querySelector(
          \`img[data-column="\${column}"][data-row="\${row}"]\`,
        );
        element.replaceWith(convertBlobToImage(blob));
      });
      promises.push(promise);
    }
  }
  return Promise.all(promises); // return a promise that resolves when all promises are resolved
}`;

const asyncIncorrectCode = `async function fetchImagesWithAsyncIncorrectly() {
  for (let column = 0; column < NR_OF_COLUMNS; column+=COL_INCREMENT) {
    for (let row = 0; row < NR_OF_ROWS; row+=ROW_INCREMENT) {
      // Here we use the async/await structure to fetch the image
      const blob = await fetchBlobImage();
      const element = imageContainer.querySelector(
        \`img[data-column="\${column}"][data-row="\${row}"]\`,
      );
      element.replaceWith(convertBlobToImage(blob));
    }
  }
}`;

const asyncCorrectCode = `function fetchImagesWithAsyncCorrectly() {
  let promises = [];
  async function getBlobAndReplaceImage(column, row) {
    const blob = await fetchBlobImage();
    const element = imageContainer.querySelector(
      \`img[data-column="\${column}"][data-row="\${row}"]\`,
    );
    element.replaceWith(convertBlobToImage(blob));
  }

  for (let column = 0; column < NR_OF_COLUMNS; column += COL_INCREMENT) {
    for (let row = 0; row < NR_OF_ROWS; row += ROW_INCREMENT) {
      promises = [...promises, getBlobAndReplaceImage(column, row)];
    }
  }
  return Promise.all(promises);
}`;

const commentPromise = `
  The promise based approach works well for concurrent operations, but can lead to deep nesting and "callback hell" if not managed properly.
  It requires careful handling of promise chains and can become less readable with complex logic.
  `;
const commentAsyncIncorrectly = `
  This demo shows what happens when using async/await incorrectly. 
  A mistake that is easy to make if you don't understand asynchronous programming well.<br/>
  <br/> 
  In this example, the loop contains the await, which causes the images to be fetched sequentially rather than concurrently.
  `;
const commentAsyncCorrectly = `
  This demo shows the correct way to use async/await for concurrent operations. 
  By defining an (inner) async function and calling it within the loop without awaiting it, we allow all fetch operations to start concurrently, 
  improving performance significantly.<br/>
  <br/>
  <strong>NOTE:</strong> That the promises array is only used to track when all operations are complete, to facilitate timing measurement.
  `;

function showCode(method) {
  let code = "";
  let comment = "";
  if (method === "promise") {
    code = promiseCode;
    comment = commentPromise;
  } else if (method === "async-incorrect") {
    code = asyncIncorrectCode;
    comment = commentAsyncIncorrectly;
  } else if (method === "async-correct") {
    code = asyncCorrectCode;
    comment = commentAsyncCorrectly;
  }
  element.innerHTML = `<pre><code class="language-javascript">${hljs.highlight(code, { language: 'javascript' }).value}</code></pre>`;
  commentElement.innerHTML = comment;
}

export { showCode };